module.exports = __webpack_public_path__ + "img/face55.fe7a620f.gif";